import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getOrderClosedCheckoutListByPointsThunk,
    getOrderOpenedCheckoutListByPointsThunk,
} from "tm-shared/api";

type FetchCheckoutListsArgs = {
    routeId: string;
    strict?: boolean;
};

export const getCheckoutsThunk = createAsyncThunk(
    "ui/fetchCheckoutLists",
    async (
        { routeId, strict }: FetchCheckoutListsArgs,
        { dispatch, rejectWithValue },
    ) => {
        if (strict) {
            try {
                await Promise.all([
                    dispatch(
                        getOrderOpenedCheckoutListByPointsThunk({ routeId }),
                    ).unwrap(),
                    dispatch(
                        getOrderClosedCheckoutListByPointsThunk({ routeId }),
                    ).unwrap(),
                ]);
            } catch (error) {
                return rejectWithValue(error);
            }

            return;
        }

        await Promise.allSettled([
            dispatch(
                getOrderOpenedCheckoutListByPointsThunk({ routeId }),
            ).unwrap(),
            dispatch(
                getOrderClosedCheckoutListByPointsThunk({ routeId }),
            ).unwrap(),
        ]);
    },
);
